import { useState, useEffect } from 'react';

function useKey(key: string): boolean {
	const [pressed, setPressed] = useState<boolean>(false);

	const match = (event: KeyboardEvent): boolean => key.toLowerCase() === event.key.toLowerCase();

	useEffect(() => {
		const onDown = (event: KeyboardEvent): void => {
			if (match(event)) {
				setPressed(true);
			}
		};

		const onUp = (event: KeyboardEvent): void => {
			if (match(event)) {
				setPressed(false);
			}
		};

		window.addEventListener('keydown', onDown);
		window.addEventListener('keyup', onUp);

		return () => {
			window.removeEventListener('keydown', onDown);
			window.removeEventListener('keyup', onUp);
		};
	}, [key]);

	return pressed;
}

export default useKey;
